import { SPANISH } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Spanish Spain
const ESSection: Section[] = [
  {
    name: '1: Referencia e información general',
    subSections: [
      {
        name: 'Prefacio',
        page: 3,
      },
      {
        name: 'Finalidad y aplicaciones de la guía de campo',
        page: 4,
      },
      {
        name: 'Definiciones clave',
        page: 5,
      },
      {
        name: 'Jerarquía de controles',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Vehículo de motor: Seguridad vial',
        page: 9,
      },
      {
        name: 'Trabajos de altura',
        page: 12,
      },
      {
        name: 'Equipos móviles con motor (MPE)',
        page: 18,
      },
      {
        name: 'Bloqueo y cierre/Aislamiento energético',
        page: 22,
      },
      {
        name: 'Trabajo eléctrico',
        page: 25,
      },
      {
        name: 'Espacio confinado',
        page: 29,
      },
      {
        name: 'Materiales a granel y almacenamiento',
        page: 32,
      },
      {
        name: 'Seguridad relacionada con vagones',
        page: 37,
      },
      {
        name: 'Trabajo de excavación y zanjas',
        page: 41,
      },
      {
        name: 'Elevación e izaje',
        page: 45,
      },
      {
        name: 'Materiales peligrosos',
        page: 49,
      },
      {
        name: 'Trabajo en caliente',
        page: 52,
      },
    ],
  },
  {
    name: '3: Herramientas y recursos adicionales',
    subSections: [
      {
        name: 'Trabajos sobre agua y alrededor…',
        page: 56,
      },
      {
        name: 'Caída de objetos',
        page: 59,
      },
      {
        name: 'Pruebas atmosféricas/de gas',
        page: 61,
      },
      {
        name: 'Comunicación de los peligros químicos',
        page: 65,
      },
    ],
  },
  {
    name: '4: Prácticas de gestión de la seguridad de Cargill',
    subSections: [
      {
        name: 'Terminología clave',
        page: 70,
      },
      {
        name: 'Determinación de lesión grave causada por un evento',
        page: 72,
      },
      {
        name: 'Clasificación del potencial para ocasionar lesiones graves',
        page: 73,
      },
      {
        name: 'Tabla de criterios para la determinación automática de lesiones graves ',
        page: 74,
      },
      {
        name: 'Desempeño humano y organizativo (HOP) ',
        page: 76,
      },
    ],
  },
];
const ESTableofContent: TableOfContent = {
  language: 'es',
  sections: ESSection,
  label: 'Tabla de contenidos',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (es_ES)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Guía de bolsillo de HOP',
  hopPocketLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Spanish (Spain).pdf',
  source: SPANISH,
};

export default ESTableofContent;
